import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-financial-amount-received',
  templateUrl: './financial-amount-received.component.html',
  styleUrls: ['./financial-amount-received.component.css']
})
export class FinancialAmountReceivedComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  dataSource: any = {
    chart: {
      numberPrefix: "R$ ",
      theme: "fusion",
      "paletteColors": "#29C2BD",
      "maxBarHeight": "14",
      showValues: "1",
      placeValuesInside: "0"
    },
    data: []
  }

  loading: boolean = true;
  errorApi: boolean = false;
  message: string = "";

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.amountReceivedInformation(item);
  }
  
  amountReceivedInformation(item: any) {
    this.api.postAmountReceivedByDocument(item.dataMin, item.dataMax, item.branch).subscribe(data => {
      try {
        this.dataSource.data = [];
        if(data.dataRow.length > 1 || (data.dataRow.length = 1 && data.dataRow[0].value_title > 0))
        {
          data.dataRow.map((el:any) => {
            this.dataSource.data.push({
              'label': el.form_receipt,
              'value': el.value_title,
              'valueBgColor': '#F9F9F9'
            })
          })
          this.loading = false;
        } else {
          this.loading = false;
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_NULL_AMOUNT_RECEIVABLE_DOCUMENT;
          this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_AMOUNT_RECEIVABLE_DOCUMENT);
        }
      } catch (error : unknown) {
        this.loading = false;
        if (error instanceof Error)
          this.message = error.message;
          this.formatErrorMensagem(this.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_AMOUNT_RECEIVABLE_DOCUMENT;
      this.formatErrorMensagem(error.message);
    });
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: financial-amount-received \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
